import { defineMessages } from 'react-intl';

export default defineMessages({
	description: {
		id: 'components.walletPayment.barcodeScanner.description',
		defaultMessage: 'با دوربین بارکد را اسکن کنید یا دستی کد را وارد کنید.',
	},
	manualButton: {
		id: 'components.walletPayment.barcodeScanner.manualButton',
		defaultMessage: 'وارد کردن دستی شماره بارکد',
	},
	exitButton: {
		id: 'components.walletPayment.barcodeScanner.exitButton',
		defaultMessage: 'انصراف',
	},
	modalTitle: {
		id: 'components.walletPayment.barcodeScanner.modalTitle',
		defaultMessage: 'انصراف از پرداخت مشتری',
	},
	insufficient: {
		id: 'components.walletPayment.barcodeScanner.insufficient',
		defaultMessage: 'موجودی کیف پول مشتری کافی نیست!',
	},
	amount: {
		id: 'components.walletPayment.barcodeScanner.amount',
		defaultMessage: 'مبلغ نهایی:',
	},
});
